import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-2 h-16 line inline-flex items-center rounded-lg relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { clas: "mx-10" }
const _hoisted_4 = { class: "mx-6 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.lineIcon,
      class: "inline p-2"
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-16 border line-vertical" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}